class WishlistForm {
  constructor(el) {
    this.form = el
    this.added = this.form.classList.contains('wishlist-form--added')
    this.submitButton = this.form.querySelector('.wishlist-form__button')
    this.handleSubmit = this.handleSubmit.bind(this)

    this.init()
  }

  async handleSubmit(e) {
    e.preventDefault()
    const { api } = window.suplementos
    const formData = new FormData(this.form)
    const endpointAction = this.added ? 'remove-from' : 'add-to'

    this.submitButton.classList.add('btn--loading')

    const response = await fetch(`${api}/${endpointAction}-wishlist`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })

    if (response.ok) {
      const result = await response.json()

      const { error } = result

      if (!error) {
        this.added = !this.added

        if (this.added) {
          this.form.classList.add('wishlist-form--added')
        } else {
          this.form.classList.remove('wishlist-form--added')
        }

        if (this.card) {
          this.card.remove()
          this.card = null
        }
      }
    }

    this.submitButton.classList.remove('btn--loading')
  }

  init() {
    this.form.addEventListener('submit', this.handleSubmit)
  }
}

const wishlist = {
  // eslint-disable-next-line consistent-return
  init() {
    const wrapperEl = document.querySelectorAll('.wishlist-form')
    Array.from(wrapperEl).forEach(button => new WishlistForm(button))
  },
}

export default wishlist
